import type { Assistant, Participant, Session } from "../types";

/** Used only when the data carries no assistant name at all. */
export const ASSISTANT_FALLBACK_NAME = "Assistant";

const named = (name: string | undefined) => name?.trim() || undefined;

/**
 * The assistant's member-facing name, always read from data. Precedence:
 * 1. the ASSISTANT-role participant of the open conversation,
 * 2. the matching entry of GET /assistants (by that participant's, else the
 *    session assistant's, member id; else the default / only entry),
 * 3. `assistant.name` from GET /session,
 * 4. "Assistant".
 */
export function assistantName(
  participants?: Pick<Participant, "role" | "name">[],
  assistants?: Pick<Assistant, "memberId" | "name" | "isDefault">[],
  session?: Pick<Session, "assistant">,
): string {
  const fromParticipant = named(
    participants?.find((participant) => participant.role === "ASSISTANT")?.name,
  );
  if (fromParticipant) return fromParticipant;
  const sessionId = session?.assistant?.memberId;
  const entry =
    (sessionId
      ? assistants?.find((assistant) => assistant.memberId === sessionId)
      : undefined) ??
    assistants?.find((assistant) => assistant.isDefault) ??
    (assistants?.length === 1 ? assistants[0] : undefined);
  return (
    named(entry?.name) ??
    named(session?.assistant?.name) ??
    ASSISTANT_FALLBACK_NAME
  );
}
